<template>
    <div id="navigation-container">
        <div id="navigation" :class="navigationClass">
            <img class="open-menu" src="@/assets/navigation/np-hamburger-menu-547176-000000@3x.png" @click="openMenu">
            <div class="nav_img">
                <a href="https://www.finish.com.tr" target="_blank">
                    <img src="@/assets/navigation/finish-logo@3x.png" alt=""/>
                </a>
            </div>
            <div class="navigation-main">
                <router-link to="/" :class="{'home-screen' : startStoryButton === 'home'}">
                    <img src="../assets/navigation/yarinin-suyu@3x.png" alt=""/>
                </router-link>
                <div id="story-container"
                     :class="{'home-screen' : startStoryButton === 'home', 'show-full' : startStoryButton === 'subPage'}">
                    <div class="nc-buttons-container">
                        <div class="start-water-print story-button-container" @click="waterPrintStart()">
                            <ButtonBlueBackground class="water-print" :text="`Su ayak İzİnİ hesapla`" :to="''"
                                                  :button-class="`grey-button`"/>
                        </div>
                        <div class="start-story story-button-container">
                            <ButtonBlueBackground class="home-start-story" :text="'Hİkayeye Başla'" :to="'/01'"
                                                  @click="storyStart()"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="nav_img">
                <img src="../assets/navigation/national-geographic-whitelogo@3x.png"
                     alt="" />
            </div>
        </div>
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
            <WaterIndex v-if="startStoryButton === 'home'"/>
        </transition>
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
            <div id="home-container" v-if="startStoryButton === 'home' ">
                <h1>TÜRKİYE’NİN Suyunu BİRLİKTE KORUYABİLİRİZ</h1>
                <div class="nc-buttons-container">
                    <div class="start-water-print story-button-container" @click="waterPrintStart()">
                        <ButtonBlueBackground class="water-print" :text="`Su ayak İzİnİ hesapla`" :to="''"
                                              :button-class="`grey-button`"/>
                    </div>
                    <div class="start-story story-button-container">
                        <ButtonBlueBackground class="home-start-story" :text="'Hİkayeye Başla'" :to="'/01'"
                                              @click="storyStart()"/>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import EventBus from "../main";
import ButtonBlueBackground from "./ButtonBlueBackground";
import WaterIndex from "./WaterIndex";

export default {
        name: "Navigation",
        data() {
            return {
                homeLinkClass: '',
                navigationClass: ''
            };
        },
        computed: {
            startStoryButton() {
                return this.$store.state.navigationStatus;
            }
        },
        methods: {
            openMenu() {
                EventBus.$emit('menu-status');
            },
            storyStart() {
                EventBus.$emit('story-start', '');
            },
            waterPrintStart() {
                EventBus.$emit('water-print-status');
                dataLayer.push({'event':'navigationMenu_startPromiseQuiz','page':window.location.pathname == '/' ? 'homepage' : window.location.pathname.replace('/','')});
            }
        },
        props: ['parent', 'in-story'],
        created() {
            EventBus.$on("home-active", () => {
                if (this.parent !== 'menu') {
                    this.homeLinkClass = "home-screen";
                }
            });
        },
        components: {
            WaterIndex,
            ButtonBlueBackground
        }
    };
</script>

<style lang="scss">
    #navigation-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        position: relative;
        z-index: 15;
        height: auto;

        #navigation {
            position: relative;
            z-index: inherit;
            display: flex;
            width: 100%;
            justify-content: space-between;
            align-items: flex-start;
            height: auto;

            @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {

                padding: 20px;
                box-sizing: border-box;
            }


            .open-menu {
                width: 38px;
                height: 38px;
                margin-bottom: auto;
                margin-left: 15px;
                margin-top: 15px;
                cursor: pointer;

                @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {

                    width: 80px;
                    height: 80px;
                }
            }

            .navigation-main {
                display: flex;
                align-items: center;
                margin: 8px auto;
                width: auto;

                > a {
                    transition: all 1s ease-in-out;
                    position: relative;
                    margin-right: 10%;
                    top: 0;

                    &.home-screen {
                        top: 195px;

                        & > img {
                            width: 196px;
                            height: 79px;
                            object-fit: contain;

                            @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                                width: 350px;
                                height: auto;
                                margin-bottom: 28px;
                            }
                        }
                    }

                    &.loading-screen {
                        top: 185px;
                    }

                    & > img {
                        width: 196px;
                        height: 51px;
                        object-fit: contain;
                        transition: all 500ms ease-in-out;

                        @media only screen and (max-device-width: 768px) {
                            width: 246px;
                            height: 101px;
                        }
                    }
                }

                .story-button-container {
                    margin: 0 15px;
                    height: auto;
                    width: 100%;

                    .blue-button {
                        width: 208px;
                        margin: 0 auto;
                    }
                }


                #story-container {
                    width: 310px;
                    margin: auto 15px;
                    overflow: hidden;
                    transition: all 250ms ease-in-out;

                    &.show-full {
                        width: 580px;
                    }

                    &.home-screen {
                        width: 0;
                    }

                    .grey-button {
                        min-width: 210px;
                    }

                    .nc-buttons-container {
                        display: flex;
                        align-items: center;
                        width: auto;
                        justify-content: flex-start;

                        .story-button-container {
                            height: auto;
                            width: auto;

                            .blue-button {
                                width: 208px;
                            }

                            &.start-water-print {
                                margin: 0 15px 0 0;
                            }

                            &.start-story {
                                margin: 0 0 0 15px;
                            }
                        }
                    }

                    @media only screen and (max-width: 1024px) {
                        display: none;
                    }
                }
            }

            & > .nav_img {
                display: block;
                height: calc(100% - 34px);

                &:nth-of-type(1) {
                    margin: 10px auto 7px 17px;

                    img {
                        width: 51px;
                        height: 35px;

                        @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {

                            width: 110px;
                            height: auto;
                            margin-left: 30px;
                        }
                    }
                }

                &:nth-of-type(3) {
                    margin: 10px 19px 0 auto;

                    img {
                        width: 98px;
                        height: 26px;
                        margin-top: 8px;

                        @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {

                            width: 200px;
                            height: auto;
                            margin-top: 15px;
                        }

                    }
                }
            }

            &.last-story {
                a:nth-of-type(2) > img {
                    width: 136px;
                    height: 55px;
                    object-fit: contain;
                }

            }
        }
    }

    #home-container {
        position: relative;
        z-index: inherit;
        padding-top: 190px;

        & > p,h1 {
            text-transform: uppercase;
            text-shadow: 0 1px 1px rgba(0, 0, 0, 0.22);
            font-family: "Quicksand", sans-serif, Tahoma;
            font-size: 33px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            color: #ffffff;
            margin-bottom: 34px;

            @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                font-size: 50px;
            }

        }

        

        .nc-buttons-container {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;

            & > div[class*="-button-container"] {
                width: 220px;
                margin: 0;

                @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                    width: 420px;
                }
            }

            .start-story {
                display: none;
                height: auto;
            }

            & > .story-button-container {
                margin: auto 15px !important;
                width: auto !important;
                display: flex;
                align-items: center;

                .blue-button,
                .grey-button {
                    width: auto;
                    min-width: 220px;

                    @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                        min-width: 100% !important;
                        max-height: 140px;
                        min-height: 140px;
                        margin: 40px 0px;
                        justify-content: flex-start;
                        padding: 0px 50px;
                        box-sizing: border-box;
                    }

                    & > p {
                        @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                            font-size: 35px;
                            margin-left: 20px;
                        }
                    }

                }
            }

            @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                width: 80%;
                flex-direction: column;
                margin: 0px auto 35px auto;
            }
        }
    }

    .story-button-container {

        @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
            height: auto !important;
        }

        > a {


            & > img {
                @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                    width: 60px;
                }
            }
        }
    }
</style>
